import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const WhatsappNew: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill={fill}
      className={className}
      aria-hidden={!title}
      focusable='false'
      {...props}
    >
      <g clipPath='url(#clip0_4216_4419)'>
        <path
          d='M0.66767 9.91475C0.667176 11.5656 1.09854 13.1775 1.91872 14.5983L0.589195 19.4526L5.55699 18.15C6.92562 18.896 8.46668 19.2898 10.035 19.2901H10.0391C15.2037 19.2901 19.4077 15.0876 19.4099 9.92215C19.4109 7.41906 18.437 5.06542 16.6676 3.29465C14.8985 1.52398 12.5457 0.548329 10.0387 0.547241C4.87362 0.547241 0.669841 4.74954 0.66767 9.91475Z'
          fill='url(#paint0_linear_4216_4419)'
        />
        <path
          d='M10.0413 0.291382C12.6158 0.292535 15.0318 1.29441 16.849 3.11267C18.6658 4.93121 19.6661 7.34852 19.6654 9.91931C19.6631 15.2235 15.345 19.5403 10.0413 19.5404H10.0374C8.42688 19.5398 6.84345 19.1359 5.43783 18.3695L5.40951 18.3539L5.37728 18.3617L0.370445 19.6742L1.71029 14.7855L1.71908 14.7513L1.7015 14.722C0.85944 13.2632 0.416734 11.6072 0.41732 9.9115C0.419706 4.6072 4.73671 0.291382 10.0413 0.291382ZM10.0443 1.76404C5.54784 1.76404 1.8908 5.41936 1.889 9.91248C1.88841 11.4521 2.31992 12.9517 3.13607 14.2494L3.30795 14.5228L2.50228 17.4642L2.4642 17.6039L2.60384 17.5668L5.62337 16.7748L5.889 16.932C7.14029 17.6744 8.57478 18.0669 10.0374 18.0677H10.0413C14.5341 18.0676 18.1906 14.4123 18.1927 9.91931C18.1933 7.74187 17.346 5.69381 15.807 4.15369C14.268 2.61382 12.2214 1.76496 10.0443 1.76404Z'
          fill='url(#paint1_linear_4216_4419)'
          stroke='#CDCDCD'
          strokeWidth='0.166667'
        />
        <path
          d='M7.61378 5.85532C7.43205 5.45138 7.24086 5.4433 7.06801 5.43619C6.92657 5.43017 6.76478 5.43055 6.60319 5.43055C6.4414 5.43055 6.17863 5.49136 5.95644 5.73398C5.73405 5.97671 5.10742 6.56346 5.10742 7.75675C5.10742 8.95017 5.97667 10.1033 6.0978 10.2653C6.21911 10.427 7.77576 12.9541 10.241 13.9264C12.29 14.7343 12.7069 14.5736 13.1516 14.5331C13.5963 14.4928 14.5867 13.9466 14.7887 13.3802C14.9909 12.8139 14.9909 12.3284 14.9303 12.2271C14.8697 12.126 14.7079 12.0653 14.4654 11.944C14.2227 11.8227 13.0303 11.2359 12.808 11.155C12.5856 11.0741 12.4239 11.0338 12.2622 11.2766C12.1005 11.5191 11.6359 12.0653 11.4944 12.2271C11.3529 12.3892 11.2114 12.4094 10.9688 12.2881C10.7262 12.1664 9.94503 11.9105 9.01834 11.0843C8.29726 10.4414 7.8105 9.64746 7.66896 9.40463C7.5275 9.16211 7.65386 9.03071 7.77546 8.9098C7.88444 8.80113 8.01811 8.62661 8.13942 8.48505C8.26044 8.3434 8.3008 8.24232 8.38165 8.08053C8.46259 7.91865 8.42213 7.777 8.3615 7.65569C8.3008 7.53438 7.82946 6.33494 7.61378 5.85532Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_4216_4419'
          x1='941.625'
          y1='1891.09'
          x2='941.625'
          y2='0.548143'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1FAF38' />
          <stop
            offset='1'
            stopColor='#60D669'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_4216_4419'
          x1='975.052'
          y1='1958.54'
          x2='975.052'
          y2='0.205923'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F9F9F9' />
          <stop
            offset='1'
            stopColor='white'
          />
        </linearGradient>
        <clipPath id='clip0_4216_4419'>
          <rect
            width='20'
            height='20'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WhatsappNew
